export default __webpack_public_path__ + "static/media/logoPrestapolisSolo.23e5669d.png";